import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface DownloadMemberDocument {
  MemberFilePath: string,
  MemberFileName: string,
  MembMpiNo: string
}

export interface DocumentsMemberInfo {
  CompanyId: string,
  MembMpiNo: string
}

export interface MemberDocument {
  key: string,
  category: string,
  documentName: any,
  tags: any,
  uploadedDate: string
}

export interface GetMemberDocument {
  RmiCompanyId: string,
  RmiDateOfService: string | null,
  RmiDocumentCategory: string,
  RmiCategoryCode: string,
  RmiDocumentTag: string,
  RmiFileName: string,
  RmiFilePath: string
  RmiFractureDate: string | null,
  RmiMeasureCode: string,
  RmiMeasureGroup: string,
  RmiMeasureGroupItem: string | null,
  RmiMeasureYear: number,
  RmiMembMpiNo: string,
  RmiModifiedBy: string,
  RmiModifiedDate: string,
  RmiOrigFileName: string,
  RmiPositiveNegative: string | null,
  RmiProvKeyId: string,
  RmiReadBy: string | null,
  RmiReadDate: string | null,
  RmiReadFlag: string | null,
  RmiScore: string | null,
  RmiSequence: number,
  RmiStatus: string | null,
  RmiTncAgreement: string,
  RmiUid: number,
  RmiUploadBy: string,
  RmiUploadDate: string,
  RmiVerifyBy: string | null,
  RmiVerifyCode: string | null,
  RmiVerifyDate: string | null,
  RmiYearsValid: string | null
}

export interface CategoryModel {
  CompanyId: string,
  MembMpiNo: string
}

export interface UpdateCategory {
  CompanyId: string,
  DocumentCategory: string,
  MeasureCode: string,
  MeasureGroup: string,
  MembMpiNo: string,
  MemberFileName: string,
  MemberFilePath: string,
  ModifiedBy: string,
  OrigFileName: string,
  ProvKeyId: string,
  Uid: number,
  UpdatedMemberFileName: string
}

export const getMemberDocuments = (memberInfo: DocumentsMemberInfo) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_DOCUMENTS_REQUEST });

  const searchModel = {
    "CompanyId": memberInfo.CompanyId,
    "MembMpiNo": memberInfo.MembMpiNo,
  };

  return api.eligibility.documents.get(searchModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_DOCUMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_DOCUMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCategory = (model: CategoryModel) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_DOCUMENT_CATEGORY_REQUEST });

  return api.eligibility.documents.getCategory(model)
    .then((res: any) => {

      dispatch({
        type: types.GET_DOCUMENT_CATEGORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DOCUMENT_CATEGORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCategoryDocs = (userId: string, membMpiNo: string, categoryDescArray: Array<any>) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CATEGORY_DOCS_FOR_MEMBER_REQUEST });

  const membDocPageRequestModel = {
    UserId: userId,
    MemberMpiNo: membMpiNo,
    DocumentCategories: categoryDescArray
  };

  return api.eligibility.documents.getCategoryDocs(membDocPageRequestModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_CATEGORY_DOCS_FOR_MEMBER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CATEGORY_DOCS_FOR_MEMBER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCategoryDocsForMemDocPage = (userId: string, categoryDescArray: Array<any>) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_REQUEST });

  const membDocPageRequestModel = {
    UserId: userId,
    DocumentCategories: categoryDescArray
  };

  return api.eligibility.documents.getCategoryDocsForMemDocPage(membDocPageRequestModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getGroupsAndCategories = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_DOCUMENT_GROUPS_AND_CATEGORIES_REQUEST });

  return api.eligibility.documents.getGroupsAndCategories(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_DOCUMENT_GROUPS_AND_CATEGORIES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DOCUMENT_GROUPS_AND_CATEGORIES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateCategory = (document: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityDocuments.isUpdating) { return Promise.reject(); }

  dispatch({ type: types.UPDATE_DOCUMENT_CATEGORY_REQUEST });

  return api.eligibility.documents.updateCategory(document)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_DOCUMENT_CATEGORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_DOCUMENT_CATEGORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const deleteMemberDoc = (document: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityDocuments.isDeleting) { return Promise.reject(); }

  dispatch({ type: types.DELETE_MEMBER_DOCUMENT_REQUEST });

  return api.eligibility.documents.delete(document)
    .then((res: any) => {

      dispatch({
        type: types.DELETE_MEMBER_DOCUMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DELETE_MEMBER_DOCUMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const downloadMemberDocument = (memberFilePath: string, memberFileName: string, membMpiNo: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityDocuments.isDownloading) { return Promise.reject(); }

  dispatch({ type: types.DOWNLOAD_MEMBER_DOCUMENT_REQUEST });

  const model = {
    "MemberFilePath": memberFilePath,
    "MemberFileName": memberFileName,
    "MembMpiNo": membMpiNo,
  };

  return api.eligibility.documents.download(model)
    .then((res: any) => {

      dispatch({
        type: types.DOWNLOAD_MEMBER_DOCUMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DOWNLOAD_MEMBER_DOCUMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMostRecentDocsForMemDocPage = (userId: string, pageSize: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.POST_LATEST_DOCUMENTS_REQUEST });

  const params = {
    "UserId": userId,
    "PageSize": pageSize
  }

  return api.eligibility.documents.getMostRecentDocsForMemDocPage(params)
    .then((res: any) => {

      dispatch({
        type: types.POST_LATEST_DOCUMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_LATEST_DOCUMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProviderByFileId = (fileId: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDERS_DOCUMENT_REQUEST });

  return api.eligibility.documents.getProviderByFileId(sessionStorage.user_id, fileId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDERS_DOCUMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDERS_DOCUMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSpecByFileId = (fileId: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SPECS_DOCUMENT_REQUEST });

  return api.eligibility.documents.getSpecByFileId(sessionStorage.user_id, fileId)
    .then((res: any) => {

      dispatch({
        type: types.GET_SPECS_DOCUMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SPECS_DOCUMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};